import React from 'react';
const items = [{
  name: '6 Tomos digitales Premium',
  value: '$97'
}, {
  name: '5 Bonos exclusivos',
  value: '$140'
}];
export function PricingSection() {
  return <section id="pricing" className="w-full bg-bg-alt py-16 sm:py-24 px-4" data-id="element-133">
      <div className="max-w-3xl mx-auto" data-id="element-134">
        <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main text-center mb-10 sm:mb-16" data-id="element-135">
          🏆 Oferta Especial de Lanzamiento
        </h2>

        <div className="bg-bg-alt rounded-3xl border-2 border-primary p-6 sm:p-10 shadow-lg relative max-w-xl mx-auto" data-id="element-136">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-primary text-white font-bold text-xs sm:text-sm px-6 py-2 rounded-full uppercase tracking-wider whitespace-nowrap" data-id="element-137">
            CONTENIDO DEL PACK PADEL LISTO:
          </div>

          <div className="mt-6 space-y-4 mb-8" data-id="element-138">
            {items.map((item, i) => <div key={i} className="flex justify-between items-center text-text-main font-medium text-base sm:text-lg border-b border-border-light pb-3" data-id="element-139">
                <span data-id="element-140">{item.name}</span>
                <span className="text-secondary line-through" data-id="element-141">
                  {item.value}
                </span>
              </div>)}
            <div className="flex justify-between items-center font-black text-lg sm:text-xl pt-2" data-id="element-142">
              <span data-id="element-143">VALOR TOTAL:</span>
              <span className="text-secondary line-through" data-id="element-144">$237 USD</span>
            </div>
          </div>

          <div className="text-center mb-8" data-id="element-145">
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-146">
              <span className="text-4xl sm:text-5xl" data-id="element-147">🏆</span>
              <span className="font-serif font-black text-5xl sm:text-7xl text-primary leading-none" data-id="element-148">
                $14 USD
              </span>
            </div>
            <p className="text-secondary line-through font-bold text-lg sm:text-xl mb-3" data-id="element-149">
              $237 USD
            </p>
            <p className="text-text-sec text-sm sm:text-base font-medium max-w-sm mx-auto" data-id="element-150">
              💳 Vas a pagar en la moneda de tu país, con conversión automática
              al tipo de cambio del día.
            </p>
          </div>

          <a href="https://padel-listo.impultienda.ar/checkout" className="btn-primary-pulse block w-full text-center bg-primary text-white font-bold text-lg sm:text-xl py-4 sm:py-5 rounded-lg hover:bg-primary-hover transition-colors mb-6" data-id="element-151">
            QUIERO EL PACK PADEL LISTO
          </a>

          <p className="text-center text-text-sec text-xs sm:text-sm font-medium flex flex-wrap items-center justify-center gap-2" data-id="element-152">
            <span data-id="element-153">Descarga inmediata</span>
            <span data-id="element-154">·</span>
            <span data-id="element-155">Pago único</span>
            <span data-id="element-156">·</span>
            <span data-id="element-157">Acceso de por vida</span>
            <span data-id="element-158">·</span>
            <span data-id="element-159">7 días de garantía</span>
          </p>
        </div>
      </div>
    </section>;
}